module.exports = __webpack_public_path__ + "static/img/14.4fb1cc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutus/14.jpg
// module id = 1PHT
// module chunks = 1